import './Tree.css';

const FolderIcon = () => (
    <svg width="13" height="11" viewBox="0 0 13 11" fill="currentColor" style={{ flexShrink: 0, opacity: 0.8 }}>
        <path d="M5.121 0H1C.448 0 0 .448 0 1v9c0 .552.448 1 1 1h11c.552 0 1-.448 1-1V3c0-.552-.448-1-1-1H6.5L5.121 0z" />
    </svg>
);

const HashIcon = () => (
    <svg width="11" height="12" viewBox="0 0 11 12" fill="currentColor" style={{ flexShrink: 0, opacity: 0.7 }}>
        <path d="M1 4h9M1 8h9M4 1L3 11M8 1L7 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
    </svg>
);

function FirstLevelCollection({ currentSubelementCollection, numOfAttributes, listOfSecondLvlSub, listOfProperties, typeLabel = "Collection" }) {
    const hasNestedCollections = listOfSecondLvlSub && listOfSecondLvlSub.length > 0;

    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            {/* Header */}
            <div style={{ display: "flex", flexDirection: "column", gap: "6px", padding: "12px 14px 10px" }}>
                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                    <span style={{ fontSize: "11px", fontWeight: "700", color: "#7c7c7c", letterSpacing: "0.06em", textTransform: "uppercase", minWidth: "38px" }}>Type</span>
                    <span style={{ background: "#f1f1f1", border: "1px solid #d3d3d3", borderRadius: "4px", padding: "2px 8px", fontSize: "12px", color: "#202020", fontWeight: "600" }}>{typeLabel}</span>
                </div>
                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                    <span style={{ fontSize: "11px", fontWeight: "700", color: "#7c7c7c", letterSpacing: "0.06em", textTransform: "uppercase", minWidth: "38px" }}>Name</span>
                    <span style={{ background: "rgba(38,144,68,0.08)", border: "1px solid rgba(38,144,68,0.3)", borderRadius: "4px", padding: "2px 8px", fontSize: "12px", color: "#269044", fontWeight: "600" }}>{currentSubelementCollection}</span>
                </div>
            </div>

            <div style={{ height: "1px", background: "#d3d3d3" }} />

            {hasNestedCollections ? (
                /* ── Tree mode ── */
                <div style={{ overflowY: "auto", flex: 1, padding: "8px 14px 12px" }}>
                    <div style={{ fontSize: "11px", fontWeight: "700", letterSpacing: "0.08em", textTransform: "uppercase", color: "#7c7c7c", marginBottom: "8px" }}>Elements</div>
                    <ul className="stree-children stree-root">
                        {listOfSecondLvlSub.map((item) => (
                            <li key={item} className="stree-item">
                                <div className="stree-pill">
                                    <FolderIcon />
                                    {item}
                                </div>
                            </li>
                        ))}
                        {numOfAttributes > 0 && (
                            <li className="stree-item">
                                <div className="stree-prop-badge">
                                    <HashIcon />
                                    {numOfAttributes} {numOfAttributes === 1 ? 'property' : 'properties'}
                                </div>
                            </li>
                        )}
                    </ul>
                </div>
            ) : (
                /* ── Clean list mode ── */
                <div style={{ overflowY: "auto", flex: 1, padding: "10px 14px" }}>
                    <div style={{ fontSize: "11px", fontWeight: "700", letterSpacing: "0.08em", textTransform: "uppercase", color: "#7c7c7c", marginBottom: "10px" }}>Properties</div>
                    {listOfProperties && listOfProperties.length > 0 ? (
                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                            {listOfProperties.map((prop, index) => (
                                <div key={index} style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                                    <label style={{ fontSize: "11px", fontWeight: "600", color: "#7c7c7c", letterSpacing: "0.06em", textTransform: "uppercase" }}>{prop.name}</label>
                                    <div style={{
                                        background: "#f8f8f8",
                                        border: "1px solid #d3d3d3",
                                        borderRadius: "5px",
                                        padding: "6px 10px",
                                        fontSize: "13px",
                                        color: prop.value === null || prop.value === "" ? "#afafaf" : "#202020",
                                        fontFamily: "'Courier New', Consolas, monospace",
                                        transition: "border-color 0.2s ease",
                                        wordBreak: "break-word"
                                    }}
                                        onMouseEnter={e => e.currentTarget.style.borderColor = "#269044"}
                                        onMouseLeave={e => e.currentTarget.style.borderColor = "#d3d3d3"}
                                    >
                                        {prop.value === null || prop.value === "" ? "—" : String(prop.value)}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div style={{ fontSize: "13px", color: "#afafaf" }}>No properties found.</div>
                    )}
                </div>
            )}
        </div>
    );
}

export default FirstLevelCollection;
